import { render, staticRenderFns } from "./IntegrationInfoText.vue?vue&type=template&id=4bf26f9c&scoped=true&"
import script from "./IntegrationInfoText.vue?vue&type=script&lang=js&"
export * from "./IntegrationInfoText.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationInfoText.vue?vue&type=style&index=0&id=4bf26f9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf26f9c",
  null
  
)

export default component.exports